import React, { Component, Fragment } from 'react';
import { Mixpanel } from '../../../common/utils/mixpanelUtil';
import { originURLMapping } from '../../../shortcut/shortcutUtils';
import { SNIPPET_TYPES } from 'drapcode-constant';
import { getCookie } from '../../home/app_util';

class TemplateDetail extends Component {
  getTemplateIcon = (snippetType) => {
    switch (snippetType) {
      case SNIPPET_TYPES.MODAL:
      case SNIPPET_TYPES.FLOATING_MODAL:
        return 'webconnect webconnect-files-alt';
      case SNIPPET_TYPES.SNIPPET:
        return 'webconnect webconnect-layout-text-window-reverse';
      case SNIPPET_TYPES.SUB_PAGE:
        return 'webconnect webconnect-file-earmark-richtext';
      case SNIPPET_TYPES.PDF_TEMPLATE:
        return 'webconnect webconnect-layout-text-sidebar-reverse';
      default:
        return 'webconnect webconnect-breadcrumb';
    }
  };

  render() {
    let token = getCookie('token');
    if (!token) {
      token = '';
    }
    const { name, uuid, projectId, currentPageId, uri, template, snippetType, version } =
      this.props;
    const redirectUrl = `${originURLMapping('Snippet')}`;
    return (
      <Fragment>
        <a
          href={`${redirectUrl}/editor/${version}/v/${projectId}/${uri}/${uuid}?token=${token}`}
          onClick={() => {
            Mixpanel.track('Opens Snippet on builder', { name, uuid });
          }}
          className={`list-group-item list-group-item-action align-items-center ${
            currentPageId === uuid ? 'active' : ''
          }`}
          style={{ cursor: 'pointer', width: '90%', float: 'left' }}
        >
          <i className={this.getTemplateIcon(snippetType)}></i>
          &nbsp;{name}
        </a>
        <a
          className="pages-list-left-menu"
          onClick={() => {
            this.props.toggleEmailSetting({ snippet: template });
            Mixpanel.track('Clicked on- Snippet form icon on builder', { name, uuid });
          }}
        >
          <span
            className="badge badge-theme"
            style={{ padding: 8, cursor: 'pointer', float: 'right' }}
          >
            <i className="gjs-caret-icon fa fa-cog" size={'md'}></i>
          </span>
        </a>
      </Fragment>
    );
  }
}

export default TemplateDetail;
